import component from "./ProfileAddAttention.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAddAttention"

export default wrapVueComponent(componentName, component)
